import httpUtil from "@/utils/httpUtil";

export const selectOrdersList = params => httpUtil.get("/storeOrders", params);


export const importOrders = params => httpUtil.post("/storeOrders/importExcel", params);
export const addOrders = params => httpUtil.post("/storeOrders", params);
export const delOrders = params => httpUtil.post("/storeOrders/delete", params);
export const exportOrders = params => httpUtil.post("/storeOrders/exportBox", params);
export const updateStatus = params => httpUtil.get("/storeOrders/updateStatus", params);
export const updateStatusIn = params => httpUtil.get("/storeOrders/updateStatusIn", params);


